'use strict';

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var factory = function factory(_ref) {
  var identifier = _ref.identifier;

  var Video = function (_React$Component) {
    _inherits(Video, _React$Component);

    function Video(props) {
      _classCallCheck(this, Video);

      var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));

      _this.startVideo = function () {
        _this.setState(_extends({}, _this.state, {
          playing: true
        }));
      };

      _this.state = {
        playing: false
      };
      return _this;
    }

    _createClass(Video, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            theme = _props.theme,
            video = _props.video,
            controls = _props.controls;
        return _react2['default'].createElement('div', {
          className: this.wrapperClass,
          onClick: this.startVideo
        }, _react2['default'].createElement('div', {
          className: theme.playerContainer
        }, _react2['default'].createElement(_reactPlayer2['default'], {
          className: theme.reactPlayer,
          url: video,
          playing: this.state.playing,
          width: '100%',
          height: '100%',
          controls: controls || this.needsControls
        })));
      }
    }, {
      key: 'service',
      get: function get() {
        var video = this.props.video;
        return (0, _utils.getServiceByUrl)(video);
      }
    }, {
      key: 'needsControls',
      get: function get() {
        var servicesThatNeedControls = ['dailymotion', 'vimeo'];
        return servicesThatNeedControls.indexOf(this.service) > -1;
      }
    }, {
      key: 'wrapperClass',
      get: function get() {
        var theme = this.props.theme;
        return (0, _classnames2['default'])(theme.videoThumbnailWrapper, _defineProperty({}, theme.mixcloud, this.service === 'mixcloud'));
      }
    }]);

    return Video;
  }(_react2['default'].Component);

  Video.displayName = identifier;
  Video.themeShape = {
    videoThumbnailWrapper: _propTypes2['default'].string.isRequired,
    preventDesktop: _propTypes2['default'].string.isRequired
  };
  Video.propTypes = {
    video: _propTypes2['default'].string.isRequired,
    theme: _propTypes2['default'].shape(Video.themeShape).isRequired,
    controls: _propTypes2['default'].bool,
    preventDesktopBehaviour: _propTypes2['default'].bool
  };
  Video.defaultProps = {
    video: 'https://www.youtube.com/watch?v=NduTgkntfT4',
    controls: false,
    preventDesktopBehaviour: false
  };
  return Video;
};

exports['default'] = factory;